import { logUser, send_messages } from 'logger';
import { DateTime } from 'luxon';

import { loginDuration, logoutTimeChange } from '@holmescorp/lcc-state';
import { subscribe } from '@holmescorp/pub-sub';
import { XAPI } from '@holmescorp/xapi';

export function do_logout(): void {
	const { ampath } = window.hcstatic;
	window.location.assign(`${ampath}/@@logout`);
}

export function xapi_logout(): void {
	const {
		portal_site: site,
		portal_userid: userid,
		association: assoc,
		product,
		xapi_urn_prefix: prefix,
		portal_locale,
		hash,
		course_session
	} = window.hcstatic;

	const duration = loginDuration();
	const now = DateTime.now();
	logoutTimeChange({ logoutTime: now.toISO() });

	const extensions: { [key: string]: any } = {
		[`${prefix}login-duration`]: duration,
		[`${prefix}login-time`]: now.toISO(),
		[`${prefix}course_id`]: course_session?.pk,
		language: portal_locale,
		revision: hash
	};

	const logoutStmt = new XAPI.Statement({
		actor: { objectType: 'Agent', name: `${userid}`, mbox: `mailto:${userid}@example.com` },
		verb: XAPI.Verbs.LOGGED_OUT,
		target: new XAPI.Activity({ id: `${prefix}${assoc?.toLowerCase()}:${product}` }),
		context: new XAPI.Context({ extensions })
	});
	XAPI.svc.set_statement({ stmnt: logoutStmt.asVersion(), site });
}

export function user_logout(): void {
	logUser.info('logout on user request');

	// xapi_logout();

	send_messages().then(
		() => do_logout(),
		() => do_logout()
	);
}

export function logout_expired(closing?: boolean): void {
	logUser.info('logout on expiration');
	if (!closing) {
		// xapi_logout();
		send_messages().then(
			() => do_logout(),
			() => do_logout()
		);
	} else {
		do_logout();
	}
}

export function goto_accessmanager(forced: boolean = true): void {
	logUser.info(`route to AM ${forced ? '(forced)' : '(requested)'}`);
	const goto_am = () => {
		const { ampath } = window.hcstatic;
		window.location.assign(`${ampath}/`);
	};
	send_messages().then(goto_am, goto_am);
}

subscribe('remote:site:login', () => {
	logUser.info(`user logged into site in another location`);
	goto_accessmanager(true);
});

export function do_welcome(): void {
	const { ampath } = window.hcstatic;
	window.location.assign(`${ampath}/@@welcome`);
}

export function send_to_welcome(): void {
	logUser.info('sending user to AM @@welcome page');
	send_messages().then(
		() => do_welcome(),
		() => do_welcome()
	);
}
